import {
  EmblaButton,
  EmblaButtonNext,
  EmblaButtonPrev,
} from '@/components/Carousel/styled';
import styled, { css } from 'styled-components';

const BUTTON_SIZE = 30;

export const StyledEmbla = styled('div')`
  position: relative;
  overflow: hidden;

  ${EmblaButton} {
    transition: all 0.3s ease-in-out;
    background: ${({ theme }) => theme.color.phantom} !important;
    width: ${BUTTON_SIZE}px;
    height: ${BUTTON_SIZE}px;
    border-radius: ${BUTTON_SIZE}px;
    box-shadow: 0px 5px 5px ${({ theme }) => theme.color.blackRGBA(0.4)};
    display: grid;
    place-content: center;

    > svg > * {
      fill: ${({ theme }) => theme.color.textSoft};
    }
    > svg {
      width: ${BUTTON_SIZE * 0.75}px;
      height: ${BUTTON_SIZE * 0.75}px;
    }

    &:disabled {
      opacity: 0;
    }
  }

  ${EmblaButtonNext} {
    right: ${({ theme }) => theme.x1spacePx}px;

    &:disabled {
      ${css`
        right: -${BUTTON_SIZE}px;
      `}
    }
  }

  ${EmblaButtonPrev} {
    left: ${({ theme }) => theme.x1spacePx}px;

    &:disabled {
      ${css`
        left: -${BUTTON_SIZE}px;
      `}
    }
  }
`;
